export default from './read-only-input';



// WEBPACK FOOTER //
// ./app/components/read-only-input/index.js